import React from "react";
import { MainNav } from "./CompanyProfileComponents/MainNav";
import { Interview } from "./InterviewComponents/Interview";

export const MainInterview = () => {
  return (
    <view>
      <MainNav />
      <Interview />
    </view>
  );
};
